<template>
  <div class="e-supporters">
    <ul>
      <li>{{ $t('system.supportedBy') }}</li>
      <li><img :src="logo"  class="e-supporters__logo Caritas" alt="Logo CJF" /></li>
      <li>{{ $t('system.supportedByAddText') }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SupportersBar',
  components: {
    // Logo
  },
  data: () => ({
    logo: require(`assets/bitmaps/logo-cjf.png`)
  })
}
</script>

<style lang="scss">
@import '_assets/supporters';
</style>
